import { IconProps } from '../';

const defaultSize = 48;

export const InfoIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      height={sizeToUse}
      width={sizeToUse}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 2.66667C8.63996 2.66667 2.66663 8.64 2.66663 16C2.66663 23.36 8.63996 29.3333 16 29.3333C23.36 29.3333 29.3333 23.36 29.3333 16C29.3333 8.64 23.36 2.66667 16 2.66667ZM17.3333 22.6667H14.6666V14.6667H17.3333V22.6667ZM17.3333 12H14.6666V9.33333H17.3333V12Z"
        fill="#2B60DE"
      />
    </svg>
  );
};
